import { FC, ReactNode } from "react";

interface MenuItemProps {
    onClick: () => void;
    className?: string;
    children: ReactNode;
}

const MenuItem: FC<MenuItemProps> = ({ onClick, className, children }) => {
    return (
        <button
            className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${className ?? ""}`}
            onClick={onClick}
        >
            {children}
        </button>
    );
};

export default MenuItem;
